export default class OffersResponse {
  static empty () {
    return new OffersResponse({ featuredOffers: { offers: [], total: 0 }, offers: [] })
  }

  constructor ({ slides = { featuredOffers: { offers: [], total: 0 }, offers: [] } }) {
    this.slides = slides
  }
}
